import { useMemo } from "react"

export const LEGACY_HEX_MAP: Record<string, string> = {
  "#4A4B4C": "#5B5B5D",
  "#323233": "#5B5B5D",
  "#1C1F2A": "#5B5B5D",
  "#77797F": "#A4A5AA",
  "#F9423A": "#EA0F14",
  "#D8FBFC": "#E8FDFE",
  "#CBEBFF": "#EBF4FB",
  "#E4D9F9": "#F6EFFF",
}

export const useColorPreset = (colorPreset: any) => {
  const color = useMemo(() => {
    if (!colorPreset) {
      return null
    }

    const preset = colorPreset?.preset ? colorPreset.preset : colorPreset

    switch (preset) {
      case "bubble":
        return "linear-gradient(270deg, #f8e49a 9.17%, #afe2e3 49.99%, #d8c4e5 91.67%)"
      case "offYellow":
        return "linear-gradient(272.79deg, #F8E49A 0%, #CA9E84 99.47%)"
      case "bondiBeach":
        return "linear-gradient(88.84deg, #1CD9CF 19.88%, #AAEBA4 67.36%, #D5F39F 99.01%)"
      case "custom": {
        const hex = colorPreset?.custom?.hex
        return hex ? (LEGACY_HEX_MAP[hex.toUpperCase()] ?? hex) : hex
      }
      case "customCss":
        return colorPreset?.customCss
      default: {
        const rawValue = typeof preset === "string" ? preset : ""
        if (rawValue.startsWith("#")) {
          return LEGACY_HEX_MAP[rawValue.toUpperCase()] ?? rawValue
        }
        return rawValue.startsWith("linear-gradient(") ? rawValue : `preset.${rawValue}`
      }
    }
  }, [colorPreset])

  return {
    color,
  }
}
